/**
 * created by artem.elyseev@racingpost.com
 *
 * Columns schema for press challenge table
 * Describes press challenge table structure
 * As well as keys to use for sorting columns
 * and custom cells
 */
import React from 'react';
import {
    sortPercents,
    sortBets,
    sortCurSeq,
    sortWins,
} from './utils';

const columns = [
    {
        key: 'turnOver',
        sortFn: sortPercents('turnOver'),
        header: () => (
            <span>
                <span className="hideToMedium_inline">turnover</span>
                <span className="hideFromMedium">t&apos;over</span>
            </span>
        )
    },
    {
        key: 'newspaperAndTipster',
        sortFn: 'alphabetic',
        header: 'newspaper & tipster'
    },
    {
        key: 'winsTips',
        sortFn: sortWins('winsTips'),
        header: 'wins-tips %',
        className: 'hideToMedium_month'
    },
    {
        key: 'favsTipped',
        sortFn: sortPercents('favsTipped'),
        className: 'hideToNarrow hideToMedium_month'
    },
    {
        key: 'napsBet',
        sortFn: sortBets('napsBet'),
        header: '£1 bet',
        className: 'hideToMedium'
    },
    {
        key: 'curSeq',
        sortFn: sortCurSeq('curSeq'),
        className: 'hideToMedium'
    },
    {
        key: 'monthWinsTips',
        sortFn: sortWins('monthWinsTips'),
        header: 'wins-tips',
        className: 'hideToMedium show_month'
    },
    {
        key: 'monthBet',
        sortFn: sortBets('monthBet'),
        header: '£1 bet',
        className: 'hideToMedium show_month'
    },
    {
        key: 'betWithCur',
        sortFn: sortBets('napsBet'),
        header: '£1 bet / cur seq',
        className: 'hideFromMedium'
    }
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/pressChallenge/columns.js